<app-top-navbar/>

<div class="wrapper">
  <app-loyalty-club-header/>

  <div class="content">
    <app-alert alertType="info"
               [withIcon]="true">
      {{ 'profile-form.cancel-confirmation.notice' | translate:{ loyalty_club_name: loyaltyClubName$ | async } }}
    </app-alert>
  </div>

  <app-loyalty-club-footer/>
</div>
